<app-directus-tooltip
  [icon]="iconClass()"
  [tooltipKey]="tooltipKey()"
  tooltipStyleClass="tooltip-bg-second-level"
  tooltipPosition="top"
  [attr.data-testid]="testId() + '-trigger'"
  (click)="open()"
></app-directus-tooltip>

<app-base-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [title]="header()"
  [testId]="testId()"
  [width]="width()"
  [cancelLabel]="cancelLabel()"
  [submitLabel]="submitLabel()"
  (submitted)="onConfirm()"
>
  <ng-content />
</app-base-dialog>
